import { sharedValidators } from '@shared/validation/SharedValidators';

const validateNotEmptyOrMessage =
  (message: string) =>
  (value?: string): boolean | string =>
    !!value?.trim().length || message;

const validateEmailOrMessage =
  (message: string) =>
  (value?: string): boolean | string =>
    sharedValidators.isValidEmailPattern(value) || message;

const validateURLOrMessage =
  (message: string) =>
  (value?: string): boolean | string =>
    sharedValidators.isValidURLPattern(value) || message;

export const formValidators = {
  validateNotEmptyOrMessage: validateNotEmptyOrMessage,
  validateEmailOrMessage: validateEmailOrMessage,
  validateURLOrMessage: validateURLOrMessage,
};
